import { CheckboxMultipleMarkedCircleIcon } from './CheckboxMultipleMarkedCircleIcon';

/**
 * author: Simran
 * id 85C35F15-1AC0-407B-BCBF-AD79B6E6DDEA
 * name checkbox-multiple-marked-circle
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-marked-circle.svg
 * tags
 * - Form 
 */
export const CheckboxesMarkedCircleIcon = CheckboxMultipleMarkedCircleIcon;
export default CheckboxesMarkedCircleIcon